import style from "./style.less";
import {Space} from "@svg/antd"
export default function Header(props:any) {
    const {items=[]} = props;
    return <Space className={style.header}>
        {
           items.map((item:any)=>{
               return <div key={item.id}>{item.title}</div>
           } )
        }
    </Space>;
  }